import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './styles/base.css';
import './styles/primitives.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
